module.exports = __webpack_public_path__ + "img/icon_project10.7725af17.png";